
/* eslint max-statements:0 */
angular.module('qkr').factory('merchantService', merchantService);
/* eslint max-params:0 */
function merchantService($rootScope, $http, appConfig, $q, utils, imageService,
                         menuService, _,
                         integrationSettingsService, integrationHelperService, APP_CONSTANT) {
    let cachedMerchantResponsePromise = null;

    const refreshMerchantInfoInternal = function(merchant) {
        const merchantInfo = merchant;
        $rootScope.merchantInfo = merchantInfo;

        // TODO: Need a better way to decide whether to show Quest fields/pages
        $rootScope.merchantInfo.showQuest = (merchantInfo !== null && merchantInfo.name === 'Yankee Stadium');

        $rootScope.merchantInfo.fullImageUrl = imageService.fullImageUrl($rootScope.merchantInfo.imageUrl);

        $rootScope.$broadcast('MerchantInfoLoaded');
        return merchantInfo;
    };

    function hasAccountManagerRole() {
        return _.find(appConfig.userRoles, (role) => role === 'ROLE_ACCOUNT_MANAGER');
    }

    return {

        merchantInfo: null,

        createMerchant(form) {
            const deferred = $q.defer();
            $http.post(appConfig.apiUrl + 'merchant/create', angular.copy(form)).then(
                (response) => {
                    deferred.resolve(response.data);
                },
                (reason) => {
                    deferred.reject(reason.data);
                });

            return deferred.promise;
        },

        listMerchants() {
            const deferred = $q.defer();

            $http.get(appConfig.apiUrl + 'merchant/list').then(
                (response) => {
                    deferred.resolve(response.data);
                }, (reason) => {
                    deferred.reject(reason);
                }
            );

            return deferred.promise;
        },

        getMerchantList(form) {
            const deferred = $q.defer();

            $http.post(appConfig.apiUrl + 'merchant/getMerchantList', angular.copy(form)).then(
                (response) => {
                    deferred.resolve(response.data);
                },
                (reason) => {
                    deferred.reject(reason.data);
                });
            return deferred.promise;
        },

        // Get the merchant info for the current user
        loadMerchantInfo() {
            if (utils.hasNoValue(this.merchantInfo)) {
                return this.refreshMerchantInfo();
            } else {   // If cached return it as a promise (allows manipulation in controller)
                const deferred = $q.defer();
                deferred.resolve(this.merchantInfo);
                return deferred.promise;
            }
        },

        loadMerchantResponse() {
            return $http.get(appConfig.apiUrl + 'merchant/getMerchantResponse', {withCredentials: true})
                .then((response) => response.data);
        },

        loadMerchantResponseForMerchant(merchantId) {
            return $http.get(appConfig.apiUrl + 'merchant/getMerchantResponse/' + merchantId, {withCredentials: true})
                .then((response) => response.data);
        },

        loadCacheableMerchantResponse() {
            if (cachedMerchantResponsePromise === null){
                cachedMerchantResponsePromise = $http.get(appConfig.apiUrl + 'merchant/getMerchantResponse', {withCredentials: true})
                    .then((response) => response.data);
            }
            return cachedMerchantResponsePromise;
        },

        /**
         * @deprecated do not use this function any more, use loadMerchantResponse() instead
         */
        refreshMerchantInfo() {
            const self = this;     // "this" inside the callback doesn't reference the same scope
            return $http.get(appConfig.apiUrl + 'merchant/getMerchantResponse', {withCredentials: true})
                .then((response) => {
                    self.merchantInfo = response.data;
                    refreshMerchantInfoInternal(self.merchantInfo);
                    return self.merchantInfo;
                });
        },

        loadMerchant(id) {
            let methodCall = 'merchant/get';
            if(id != null) {
                methodCall = 'merchant/get/' + id;
            }
            return $http.get(appConfig.apiUrl + methodCall, {withCredentials: true})
                .then((response) => response.data);
        },

        refreshMerchantInfoWithMerchant(merchant) {
            this.merchantInfo = merchant;
            refreshMerchantInfoInternal(this.merchantInfo);
            return this.merchantInfo;
        },

        loadDashboardInfo() {
            // Do not cache this
            return $http.get(appConfig.apiUrl + 'merchant/getDashboardData', {withCredentials: true})
                .then((response) => response.data);
        },

        loadOnboardingInfo() {
            return $http.get(appConfig.apiUrl + 'merchant/getOnBoardingStatus', {withCredentials: true})
                .then((response) => response.data);
        },

        getSkusInUse() {
            return $http.get(appConfig.apiUrl + 'merchant/getSkusInUse/', {withCredentials: true})
                .then((response) => {
                    const skusInUse = [];

                    angular.forEach(response.data, (skuStringWrapper) => {
                        skusInUse.push(skuStringWrapper.value);
                    });

                    return skusInUse;
                });
        },

        updateStateMerchant(id, state) {
            const merchant = {id, state};
            return $http.post(appConfig.apiUrl + 'merchant/changeState', merchant)
                .then((promise) => promise.data);
        },

        updateOptions(templateReport) {
            return $http.post(appConfig.apiUrl + 'merchant/updateOptions', templateReport)
                .then((promise) => promise.data);
        },

        updateAccountancySettings(accountancySettings) {
            return $http.post(appConfig.apiUrl + 'merchant/updateAccountancySettings',
                accountancySettings).then((promise) => promise.data);
        },

        updateSettings(form) {
            return $http.post(appConfig.apiUrl + 'merchant/updateSettings', form);
        },

        uploadTermsAndConditionsFile(file) {
            const fd = new FormData();
            fd.append('termsAndConditionsFile', file);
            return $http.post(appConfig.apiUrl + 'termsAndConditionsUpload/uploadTermsAndConditionsFile', fd, {
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            });
        },

        uploadPrivacyFile(file) {
            const fd = new FormData();
            fd.append('privacyFile', file);
            return $http.post(appConfig.apiUrl + 'termsAndConditionsUpload/uploadPrivacyFile', fd, {
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            });
        },

        deleteMerchant(name) {
            return $http.post(appConfig.apiUrl + 'merchant/deleteMerchant', {field: name});
        },

        getMerchantComtrexSecurityCode(merchantName) {
            return $http.get(appConfig.apiUrl + 'merchant/getMerchantComtrexSecurityCode/'
                + merchantName).then((response) => response);
        },

        getFraudCheckConfigurationByMerchant(id) {
            return $http.get(appConfig.apiUrl + 'merchant/' + id + '/getFraudCheckConfigurationByMerchant',
                {withCredentials: true}).then((response) => response.data, (err) => null);
        },

        updateFraudSettings(form) {
            return $http.post(appConfig.apiUrl + 'merchant/updateFraudSettings', form);
        },

        // Create blank share menu for comtrex pos
        createShareMenuForPos(merchant) {
            const shareMenuForm = {};
            shareMenuForm.availability = {};
            shareMenuForm.availability.isPreorderable = false;
            shareMenuForm.availability.fixedPreorderType = false;
            shareMenuForm.shared = true;
            shareMenuForm.name = APP_CONSTANT.DEFAULT_SHARED_MENU_NAME;
            shareMenuForm.merchant = merchant;
            menuService.createShareMenuForPos(shareMenuForm);
        },

        disableAnalytics(id, disableAnalytics) {
            const disableAnalyticsCommand = {
                id,
                disableAnalytics
            };
            return $http.post(appConfig.apiUrl + 'merchant/disableAnalytics', disableAnalyticsCommand);
        },

        disableAllAnalytics(disableAnalytics) {
            return $http.post(appConfig.apiUrl + 'merchant/disableAllAnalytics', {value: disableAnalytics});
        },

        getOutletsFeatures(merchant) {
            let data = $http.get(appConfig.apiUrl + 'merchant/getOutletsFeatures?' + merchant.id,
                {withCredentials: true}).then((response) => response.data, (err) => null);
            return data;
        },

        /*
        @deprecated Do not modify this method any more as it is deprecated. Please use merchantinfo-hide/show directive instead.
         */
        behaviour(merchant, behaviourName) {
            let ret = false;

            // these defaults reduce the need for subsequent undefined checks
            const defaults = {
                merchantPosProperties: {},
                options: {},
                contactDetails: {
                    country: {}
                },
                businessCategory: {
                    name: null
                },
                enableSubsidisedProduct: false
            };

            const m = _.merge({}, defaults, merchant);
            // new integration settings for old rules, trying to remove all duplication code
            const flattenData = integrationHelperService.convertServerDataToFlatten(merchant);
            const integrationDetails = integrationSettingsService.integrationDetails(flattenData);
            const isPos = integrationDetails.isPos;
            const isPaymentez = integrationDetails.isPaymentez;
            const isEunoia = integrationDetails.isEunoia;
            const isDemoPos = integrationDetails.isDemo;
            const isCollection = integrationDetails.isCollection;
            const isCollectionWithTimeSlots = integrationDetails.isCollectionWithTimeSlots;
            const isPat = integrationDetails.isPayAtTable;
            const isBarTab = integrationDetails.isBarTab;
            const isOrderAtTable = integrationDetails.isOrderAtTable;
            // I'll get ride of this confusing name isPATWithOrderAtTable later
            const isPATWithOrderAtTable = isPat && isOrderAtTable;
            // this is the most confusing isPATorBarTab(gonna fix it later)
            // keeping this comment >> if isPATWithOrderAtTable then isPATorBarTab must be false ... weird
            const isPATorBarTab = (isPat || isBarTab) && !isPATWithOrderAtTable;
            // end new integration settings
            const country = utils.get(m, 'contactDetails.country.isoCode');
            const businessCategory = m.businessCategory.name;
            const accountancyPackage = m.accountancyPackage ? m.accountancyPackage.name : "";


            function matchCategories(...categories) {
                return categories.includes(businessCategory);
            }

            function matchCountry(...countries) {
                return countries.includes(country.toString().toUpperCase());
            }

            function matchPackage(...packages) {
                return packages.includes(accountancyPackage);
            }

            switch (behaviourName) {
                case 'adminPage.hideInventoryTab':
                    ret = matchCategories('School', 'University');

                    if (isDemoPos) {
                        ret = false;
                    }
                    break;
                case 'adminPage.hideMarketingTab':
                    ret = matchCategories('School', 'University', 'Supplier') || (isPATorBarTab || isPATWithOrderAtTable);

                    if (isPaymentez) {
                        ret = false;  // NEVER ever ever hide coupons for PTZ QKRD-6525
                    }
                    break;
                case 'adminPage.hideSeatingMap':
                    ret = true;
                    break;
                case 'adminPage.hideProduct':
                    ret = isPATorBarTab && !isDemoPos;
                    break;
                case 'adminPage.hideOptionSet':
                    ret = isPATorBarTab;
                    break;
                case 'adminPage.hideMenus':
                    ret = matchCategories('School', 'University');
                    break;
                case 'adminPage.hideCoupons':
                    ret = matchCategories('School', 'University', 'Supplier') ||
                        (isPATorBarTab || isPATWithOrderAtTable);
                    if (ret) {
                        ret = (!appConfig.isMCAdmin);
                    }
                    if (isPaymentez) {
                        ret = false;  // NEVER ever ever hide coupons for PTZ QKRD-6525
                    }
                    break;
                case 'adminPage.hidePaymentGateway':
                    ret = matchCategories('School', 'University', 'Supplier');
                    break;
                case 'adminPage.hideTaxSettings':
                    ret = matchCategories('Charity');
                    break;
                case 'storeFrontPage.showFinance1Accountancy':
                    ret = matchCategories('School') &&
                        matchCountry('AU') &&
                        matchPackage(APP_CONSTANT.FINANCE1_REPORT);
                    break;
                case 'storeFrontPage.showDeptManagement':
                case 'storeFrontPage.showUserManagement':
                case 'storeFrontPage.showChangePassword':
                case 'storeFrontPage.showForms':
                case 'storeFrontPage.showRefunds':
                case 'storeFrontPage.showForum':
                    ret = matchCategories('School', 'University', 'Supplier');
                    break;
                case 'storeFrontPage.showStudents':
                    ret = matchCategories('School', 'University', 'Supplier');
                    break;
                case 'storeFrontPage.showMarketing':
                    ret = matchCategories('School', 'University', 'Supplier');
                    break;
                case 'storeFrontPage.showDemoPosFeatures':
                    ret = (isDemoPos);
                    break;
                case 'storeFrontPage.showDemoPosPATFeatures':
                    ret = (isDemoPos && m.options.payAtTable);
                    break;
                case 'storeFrontPage.showDemoPosBarTabFeatures':
                    ret = (isDemoPos && m.barTabEnabled);
                    break;
                case 'storeFrontPage.showDashboardLink':
                case 'storeFrontPage.showNewMenus':
                case 'storeFrontPage.showMultiFeaturesMenu':
                    ret = !matchCategories('School', 'University', 'Supplier');
                    break;
                case 'storeFrontPage.showMultiFeatures':
                    ret = !matchCategories('School', 'University', 'Supplier', 'Charity');
                    break;
                case 'storeFrontPage.hideCoupons':
                    ret = matchCategories('School', 'University', 'Supplier') ||
                        (isPATorBarTab || isPATWithOrderAtTable);
                    if (ret) {
                        ret = (!appConfig.isMCAdmin);
                    }
                    if (isPaymentez) {
                        ret = false;  // NEVER ever ever hide coupons for PTZ QKRD-6525
                    }
                    break;
                case 'storeFrontPage.hideProduct':
                    ret = isPATorBarTab && !isDemoPos;
                    break;
                case 'storeFrontPage.hideOptionSet':
                    ret = isPATorBarTab;
                    break;
                case 'storeFrontPage.showAccountingOptionForProfileUpload':
                    ret = matchCategories('School') &&
                        (matchCountry('GB') || matchCountry('AU')) &&
                        matchPackage('ICON') &&
                        m.enableProfileValidation;
                    break;
                case 'deptEditPage.showAddPaymentConfigButton':
                    ret = matchCategories('School', 'University', 'Supplier');
                    break;
                case 'deptEditPage.isExternalDeptCodeRequired':
                    ret = matchCategories('School') &&
                        matchCountry('GB') &&
                        matchPackage('ICON');
                    break;
                case 'deptEditPage.showLedgerReference':
                    ret = matchCategories('School') &&
                        matchCountry('GB') &&
                        matchPackage('ICON');
                    break;
                case 'deptEditPage.isFinance1':
                    ret = matchCategories('School') &&
                        matchCountry('AU') &&
                        matchPackage(APP_CONSTANT.FINANCE1_REPORT);
                    break;
                case 'legacyConfigPage.hideFulfilment':
                    ret = isPos;
                    break;
                case 'legacyConfigPage.showStickersReport':
                    ret = matchCategories('School', 'University', 'Supplier');
                    break;
                case 'reportsPage.showStickersReport':
                case 'reportsPage.showStockReport':
                case 'reportsPage.showTallyReport':
                    ret = matchCategories('School', 'University', 'Supplier');
                    break;
                case 'couponPage.deptBasedCoupon':
                    ret = matchCategories('School', 'University', 'Supplier');
                    break;
                case 'couponPage.supplyCoupon':
                    ret = matchCategories('Supplier');
                    break;
                case 'dashboardPage.showDepts':
                    ret = matchCategories('School', 'University', 'Supplier');
                    break;
                case 'dashboardPage.hideProduct':
                    ret = isPATorBarTab;
                    break;
                case 'departmentListPage.allowedHideShowDept':
                    ret = !matchCategories('Supplier');
                    break;
                case 'inventoryPage.hideCreateProduct':
                    ret = isPos && !isDemoPos;
                    break;
                case 'inventoryPage.allowEdit':
                    ret = !isPos || isDemoPos;
                    break;
                case 'inventoryPage.showCreateFirstProduct':
                case 'inventoryPage.showStock':
                case 'inventoryPage.allowEditOnOutletLevel':
                    ret = matchCategories('School', 'University', 'Supplier');
                    break;
                case 'inventoryPage.disableEditOnOutletLevel':
                    if (!hasAccountManagerRole()) {
                        // Disable inventory edit at outlet level for POS merchants with one exception for
                        // Paymentez(who is a POS Merchant)
                        ret = isPos && !isPaymentez;
                    }
                    break;
                case 'inventoryPage.charityProduct':
                    ret = matchCategories('Charity');
                    break;
                case 'inventoryPage.showLedgerAnalysis':
                    ret = matchCategories('School') &&
                        matchCountry('GB') &&
                        matchPackage('ICON');
                    break;
                case 'menuPage.disableEditOnOutletLevel':
                    ret = matchCategories('School', 'University') || isPos;
                    break;
                case 'paymentSetting.isAustralia':
                    ret = matchCountry('AU');
                    break;
                case 'paymentSetting.isSupplier':
                    ret = matchCategories('Supplier');
                    break;
                case 'paymentSetting.showBankAccountType':
                    ret = matchCountry('AU') && matchCategories('School', 'University', 'Supplier');
                    break;
                case 'paymentPage.allowedSetDefaultAtOutletLevel':
                case 'paymentPage.showDepartmentsCol':
                case 'paymentPage.showDefaultForMerchantCol':
                    ret = matchCategories('School', 'University', 'Supplier');
                    break;
                case 'paymentPage.allowedMarkActive':
                case 'paymentPage.showActiveCol':
                    ret = !matchCategories('School', 'University', 'Supplier');
                    break;
                case 'outletsPage.showMultiFeatures':
                    ret = false;
                    break;
                case 'outletsPage.showCreateOutletButton':
                case 'settingsPage.showTipping':
                case 'settingsPage.showOrderReadySettings':
                case 'inventoryItemPage.showAgeRestriction':
                    ret = !matchCategories('School', 'University', 'Supplier');
                    break;
                case 'inventoryItemPage.showStockLevel':
                    ret = matchCategories('School', 'University', 'Supplier');
                    break;
                case 'settingsPage.showMerchantId':
                    ret = !matchCategories('School', 'University', 'Supplier');
                    break;
                case 'settingsPage.showMultiFeatures':
                    ret = !matchCategories('School', 'University', 'Supplier', 'Charity');
                    break;
                case 'settingsPage.showShareTaxId':
                    ret = matchCategories('Charity');
                    break;
                case 'settingsPage.showCostCenter':
                    ret = matchCategories('School') && matchCountry('GB') && matchPackage('ICON');
                    break;
                case 'settingsPage.showMerchantRegistrationId':
                    if (matchCategories('School')) {
                        return true;
                    }
                    return false;
                    break;
                case 'settingsPage.showProfileValidation':
                    if (matchCategories('School')) {
                        return ((matchCountry('GB') && matchPackage('ICON')) ||
                        (matchCountry('AU') && matchPackage(APP_CONSTANT.FINANCE1_REPORT)))
                    }
                    break;
                case 'settingsPage.showSubsidisedProduct':
                    ret = matchCategories('School') && m.enableProfileValidation;
                    break;
                case 'settingsPage.showBeneficiaryAllowance':
                    ret = matchCategories('School') && m.enableProfileValidation && m.enableSubsidisedProduct;
                    break;
                case 'settingsPage.showMerchantRegistrationAsRequired':
                    ret = matchCategories('School') &&
                        ((matchCountry('GB') && matchPackage('ICON')) ||
                        (matchCountry('AU') && matchPackage(APP_CONSTANT.FINANCE1_REPORT)));
                    break;
                case 'transReportPage.showHeaderDisplayFields':
                    ret = matchCategories('School', 'University');
                    break;
                case 'transReportPage.showDepartments':
                case 'stockReportPage.showDepartments':
                case 'reportPage.collapseHeaders':
                case 'transReportPage.showExtendedScheduleIntervals':
                    ret = matchCategories('School', 'University', 'Supplier');
                    break;
                case 'transReportPage.showFulfilledByCheck':
                case 'transReportPage.showFulfilledDateCheck':
                case 'transReportPage.showPosItemCodeCheck':
                    ret = !matchCategories('School', 'University', 'Supplier', 'Charity');
                    break;
                case 'sharedMenusPage.showCreateSharedMenuButton':
                    ret = !matchCategories('School', 'University', 'Supplier', 'Charity') && (!isPos || isDemoPos);
                    break;
                case 'sharedMenusPage.showEditOrDeleteButton':
                    ret = !isPos;
                    break;
                case 'optionSetPage.charityOptionSet':
                    ret = matchCategories('Charity');
                    break;
                case 'optionSetPage.allowEdit':
                    ret = !isPos || isDemoPos;
                    break;
                case 'optionSetPage.showCreateFirstOptionSet':
                case 'optionSetPage.allowEditOnOutletLevel':
                    ret = matchCategories('School', 'University', 'Supplier');
                    break;
                case 'optionSetPage.disableEditOnOutletLevel':
                    if (!hasAccountManagerRole()) {
                        ret = isPos && !isPaymentez;
                    }
                    break;
                case  'menu.showAddProductButton':
                    ret = !isPos || isDemoPos;
                    break;
                case 'editMenuPage.isSharedMenuReadOnly':
                    ret = isPATorBarTab;
                    break;
                case 'editMenuPage.charityMenu':
                    ret = matchCategories('Charity');
                    break;
                case 'editMenuPage.hideMenuType':
                case 'editMenuPage.hideAvailability':
                    ret = !matchCategories('School', 'University', 'Supplier');
                    break;
                case 'editMenuPage.showMenuSubsidised':
                    ret = (m.enableSubsidisedProduct || matchCategories('Supplier')) && country !== 'AU';
                    break;
                case 'editMenuItemPage.hideAvailability':
                case 'editMenuItemPage.hideNotificationSchedule':
                case 'editMenuItemPage.hideForms':
                    ret = !matchCategories('School', 'University', 'Supplier');
                    break;
                case 'requiresBeneficiary':
                case 'editMenuItemPage.showPurchaseTypeOptions':
                case 'schoolLike':
                case 'allowSuspendReport':
                    ret = matchCategories('School', 'University', 'Supplier');
                    break;
                case 'storefrontContacts.noOpeningHours':
                    ret = matchCategories('School', 'University', 'SeedData', 'Magazine');
                    break;
                case 'settingsPage.showServiceCharge':
                    if (country === 'SG') {
                        ret = !matchCategories('School', 'University', 'Supplier');
                    } else {
                        ret = false;
                    }
                    break;
                case 'settingsPage.showHomeDelivery':
                case 'storeFrontPage.showHomeDelivery':
                    ret = Boolean(m.hasAPIPartner);
                    break;
                case 'menuPage.paymentez.showMenuSyncButton':
                    ret = isPaymentez;
                    break;
                case 'menuPage.eunoia.showMenuSyncButton':
                    ret = isEunoia;
                    break;
                default:
                    console.error('merchantService.behaviour: Unknown behaviour ' + behaviourName);
                    break;
            }
            return ret;
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/merchant.services.js